const MOOD_LINE_PREFIX = "Mood & palette:";

// The stored prompt is subject + mood + a large fixed style/composition/negative-prompt
// boilerplate block, joined with "\n\n" (see buildPromptForStyleText in
// src/services/characterImage.ts). Only the first one or two segments are the actual
// entity-specific description; everything after that is style boilerplate with no
// descriptive value, so we drop it rather than dumping the whole prompt into alt text.
export function getEntityImageAltText(entityName: string, prompt: string | null | undefined, imageNoun = "portrait"): string {
  const trimmed = prompt?.trim();
  if (!trimmed) {
    return `${entityName}'s ${imageNoun}`;
  }

  const [subject, maybeMood] = trimmed.split("\n\n");
  const mood = maybeMood?.startsWith(MOOD_LINE_PREFIX) ? maybeMood : null;
  return [subject, mood].filter(Boolean).join(" ");
}
